import React, { Fragment } from "react";
import { TextField } from "office-ui-fabric-react/lib/TextField";
class NumberInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            min: props.column.min === undefined ? 0 : props.column.min,
            max: props.column.max === undefined ? 100000 : props.column.max,
            precision:
                props.column.precision === undefined ? 0 : props.column.precision,
            value: props.value,
            key: props.column.key,
            name: props.column.name,
            validatedValue: props.value
        };
    }

    precision(a) {
        var e = 1;
        while (Math.round(a * e) / e !== a) e *= 10;
        return Math.log(e) / Math.LN10;
    }
    getValue() {
        // should return an object of key/value pairs to be merged back to the row
        var value = {};
        value[this.state.key] = this.state.validatedValue;
        return value;
    }

    getInputNode() {
        // If applicable, should return back the primary html input node that is used to edit the data
        // Otherwise return null
        // If value is an input node, then this node will be focussed on when the editor opens
        //return ReactDOM.findDOMNode(this).getElementsByTagName("input")[0];
    }

    render() {
        return (
            <Fragment>
                <TextField
                    value={this.state.value}
                    onChange={event => {
                        this.setState({ value: event.target.value });
                    }}
                    onGetErrorMessage={value => {
                        if (!isNaN(value)) {
                            if (this.state.min > value) {
                                return `Invalid Entry: Number must be greater then ${
                                    this.state.min
                                    }`;
                            }
                            if (this.state.max < value) {
                                return `Invalid Entry: Number must be less then ${
                                    this.state.max
                                    }`;
                            }
                            if (this.precision(Number(value)) > this.state.precision) {
                                return `Invalid Entry: Max decimal precision of ${
                                    this.state.precision
                                    }`;
                            }

                            this.setState({ validatedValue: this.state.value });
                        } else {
                            return "Invalid Entry: Must be number";
                        }
                    }}
                    blur={value => {
                        if (!isNaN(value)) {
                            this.setState({ validatedValue: this.state.value });
                        } else {
                            this.setState({ value: this.state.validatedValue });
                        }
                        return isNaN(value) ? "Invalid Entry: Must be number" : "";
                    }}
                />
            </Fragment>
        );
    }
}
export default NumberInput;
